import { render, staticRenderFns } from "./SupplierQuotesSection.vue?vue&type=template&id=2ae52518"
import script from "./SupplierQuotesSection.vue?vue&type=script&lang=js"
export * from "./SupplierQuotesSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports